import { Injectable } from '@angular/core';
import { Move } from './move';
import { MovesIndexRequest } from './moves-index-request';
import { ApiService } from '@utility/http/api.service';

@Injectable({ providedIn: 'root' })
export class MoveService extends ApiService<Move, MovesIndexRequest> {
    protected baseUrl = 'moves';
}
